import { render, staticRenderFns } from "./consultInformation.vue?vue&type=template&id=5abc37c4&scoped=true&"
import script from "./consultInformation.vue?vue&type=script&lang=js&"
export * from "./consultInformation.vue?vue&type=script&lang=js&"
import style0 from "./consultInformation.vue?vue&type=style&index=0&id=5abc37c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc37c4",
  null
  
)

export default component.exports